<template>
  <app-layout title="Organisations">
    <PageTitle :headerTitle="title"> </PageTitle>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="row">
        <div class="col-lg-12 col-12 text-center">
          <h5 class="">Your Organisations</h5>
           <h6 class="text-center">(Select an organisation to deploy the product)</h6>
            <br> 

            <div class="grid justify-items-center" v-for="(d, b) in tenantData" :key="b">
            <div class="border border-gray-300 bg-white w-40 mt-1">
              <a v-bind:href="'billingacc'+'?product_id='+productId+'&organisation_id='+d.id" class="no-decoration text-center text-black p-2 mt-3" > 
               {{ d.name }}
              </a>
            </div>
          </div>


          <div class="mx-4 text-center list-group" >
              
          </div>

            <ul class="text-center mt-2">
                <li class="text-center" >
                  <jet-nav-link href="/tenants/create" style="background-color:blue; border:1px solid white; " class="text-white hover:no-underline text-center">
                    <i class="fas fa-plus create-organisaction-icon"></i>&nbsp;Create an organisation
                  </jet-nav-link>
                </li>
            </ul>
        </div>
      </div>
    </div>    
  </app-layout>
</template>
<style>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .img-company {
        width: 50px;
        height: 50px;
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }



    .organisations-container {
        width: 50% !important;
        background: var(--white);
    }

    .ul-add-organisation {
        background-color: var(--blue);
    }


    .btn-submit {
        background-color: var(--blue);
    }
    
    </style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      tenantData: null,
      productData:null,
      title: "Organisations",
      productId:"",
    };
  },
  methods: {
    getProductId(){
    let urlParams = new URLSearchParams(window.location.search);
    console.log("Product ID:"+urlParams.get('product_id')); 
    this.productId=urlParams.get('product_id');
    },
    getOrganisation() {
      axios.get("tenants/list").then((response) => {
        this.tenantData = response.data.results.data;
      });
    },
  },
  mounted() {
    this.getOrganisation();
    this.getProductId();
  },
};
</script>
